<template>
  <page-outline :title="titleLabel"
    iconFA="address-book">

    <template slot="pageContent">
      <b-row class="justify-content-start">
        <b-col sm="6" class="form-group" v-if="type === '1'">
          <form-write-group-label-input v-model="companyName" isMandatory
            :inputLabel="$t('administration.company_name')" :placeholderValue="$t('administration.company_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="type === '1'">
          <form-write-group-label-input v-model="companyNumber" isMandatory
            :inputLabel="$t('administration.company_number')" :placeholderValue="$t('administration.company_number')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="type === '1'">
          <form-write-group-label-input v-model="companyEmail" isMandatory
            :inputLabel="$t('administration.company_email')" :placeholderValue="$t('administration.company_email')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="type === '2'">
          <form-write-group-label-input v-model="userLastName" isMandatory
            :inputLabel="$t('administration.user_last_name')" :placeholderValue="$t('administration.user_last_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="type === '2'">
          <form-write-group-label-input v-model="userFirstName" isMandatory
            :inputLabel="$t('administration.user_first_name')" :placeholderValue="$t('administration.user_first_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group" v-if="type === '2'">
          <form-write-group-label-input v-model="userEmail" isMandatory
            :inputLabel="$t('administration.user_email')" :placeholderValue="$t('administration.user_email')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input isMandatory
            :inputLabel="$t('administration.country')"
            inputType="listeSelect">
            <select class="form-control" readonly v-model="selectedCountry">
              <option value="">{{ $t('administration.country_select') }}</option>
              <option v-for="country in countries" :value="country">
                {{country}}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>
    </template>
    <template slot="footerButtons">
      <b-row>
        <b-col md="2" offset-md="9">
          <f7-button
            class="button-action milkyBlockBlack"
            @click="addUser">
            <f7-icon fa="save"></f7-icon>
            <span>{{ $t('common.sve') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import countriesData from '@/pages/administration/data/countries.json'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'UserEdit',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  props: {
    type: {
      default: '2',
      type: String
    }
  },
  computed: {
    titleLabel () {
      if (this.type === '1') {
        return this.$t('administration.company_addition')
      } else if (this.type === '2') {
        return this.$t('administration.user_addition')
      }
    }
  },
  data: () => {
    return {
      companyEmail: '',
      companyName: '',
      companyNumber: '',
      countries: [],
      countriesData: countriesData.countries,
      country: '',
      selectedCountry: '',
      userEmail: '',
      userFirstName: '',
      userLastName: ''
    }
  },
  created () {
    for (let countryKey in this.countriesData) {
      this.countries.push(this.countriesData[countryKey].name)
    }
  },
  methods: {
    addUser () {
      if (this.type === '1') {
        if (this.companyName === '') {
          this.$f7.alert('Company name missing', 'Error')
          return
        } else if (this.companyNumber === '') {
          this.$f7.alert('Company number missing', 'Error')
          return
        } else if (this.companyEmail === '') {
          this.$f7.alert('Company email missing', 'Error')
          return
        } else if (this.selectedCountry === '') {
          this.$f7.alert('Country missing', 'Error')
          return
        }
      } else if (this.type === '2') {
        if (this.userLastName === '') {
          this.$f7.alert('Last name missing', 'Error')
          return
        } else if (this.userFirstName === '') {
          this.$f7.alert('First name missing', 'Error')
          return
        } else if (this.userEmail === '') {
          this.$f7.alert('Email missing', 'Error')
          return
        } else if (this.selectedCountry === '') {
          this.$f7.alert('Country missing', 'Error')
          return
        }
      } else {
        this.$f7.alert('Type error', 'Error')
        return
      }
      this.$f7.showPreloader(this.$i18n.t('registerPage.rgstrng'))
      let that = this
      this.$engine.accounts.createUserAccount({
        companyName: this.companyName,
        companyNumber: this.companyNumber,
        firstName: this.userFirstName,
        lastName: this.userLastName,
        country: this.selectedCountry,
        companyEmail: this.companyEmail,
        userEmail: this.userEmail,
        type: this.type
      })
      .then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t(that.type === '1' ? that.$i18n.t('administration.company_added_success') : that.$i18n.t('administration.user_added_success')),
          text: that.$i18n.t(that.type === '1' ? that.$i18n.t('administration.company_added_success_comment') : that.$i18n.t('administration.user_added_success_comment'))
        })
        setTimeout(function () {
          that.$f7.closeModal()
          loadPage(that, {
            url: '/administration/accounts/', force: false, ignoreCache: false
          })
        }, 2000)
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that, that.$i18n)
      })
    }
  }
}
</script>
